<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    @select="v=>$emit('change',v)"
    placeholder="请选择产品"
    :clearable="clearable"
    idKey="ProductId"
    labelKey="ProductName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  components: { commonSelect },
  data() {
    return {
       api: require("@/api/ba/product").default,
    };
  },
  methods: {
    getDataFunc(params) {
      params = { ...params, ...this.params };
      // console.log("params", params);
      return new Promise((resolve, reject) => {
        this.api.list({ ...params }).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>

